<template>
  <section >
      <supplier-card v-if="supplier!='all'"
        :supplier="supplier"
      />
      <template v-else>
        <div v-if="loading">Loading suppliers</div>
        <template v-else>
            <section
                v-for="item in suppliers.data.allSuppliers"
                :key="item.entity_id"
            >
                <supplier-card
                  :supplier="item"
                />
            </section>
         </template>
      </template>
  </section>
</template>

<script>
import gql from 'graphql-tag'
import { GET_ALL_SUPPLIERS } from '../../../graphql/queries/suppliers'
import SupplierCard from './SupplierCard.vue'

export default {
  name: 'SupplierListing',
  components: {
    SupplierCard
  },
  props: {
    supplier: {
      default: 'all'
    }
  },
  data () {
    return {
      loading: true,
      lang: this.$store.getters.getLang
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    getLangForGraphQL () {
      switch (this.lang) {
        case 'fr':
          return 'fr-CA'
        default:
          return 'en-CA'
      }
    },

    async loadData () {
      try {
        const query = gql`
        query {
          ${GET_ALL_SUPPLIERS
    .replace('$lang', this.lang)

}}`
        this.suppliers = await this.$apollo.query({ query })

        // After the loader completes, update the props and loading state
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    }
  }
}

</script>